var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-default",class:[_vm.layoutClass],style:({ background: `url(${_vm.adBanner}) no-repeat center top` }),attrs:{"id":"layout-default"}},[_c('header',{staticStyle:{"height":"80px"}},[_c('HeaderVll')],1),_c('BackTop'),_c('router-view'),_c('FooterDefault')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }